export default __webpack_public_path__ + "static/media/caleb-small-calendar-icon.7fdaa15b.svg";